import React from 'react';

// Northern lights: soft colour bands slowly swaying across the top of the sky
function Aurora() {
  return (
    <>
      <div className="aurora-band aurora-band-1" />
      <div className="aurora-band aurora-band-2" />
      <div className="aurora-band aurora-band-3" />
    </>
  );
}

export default Aurora;
